const menu = {
    label: 'Leads',
    icon: 'pi pi-fw pi-comments',
    to: '/rdstation/leads',
    rules: ['RD-LEADS-00'],
};

export default menu;
